import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { of } from 'rxjs'
import { catchError, map, switchMap } from 'rxjs/operators'
import { MyCiceroWebApiService } from '../../shared/mycicero-web-api/my-cicero-web-api.service'
import { mapListInternationalDataOutput } from '../../shared/international-data/international-data'
import * as fromActions from '../actions'

@Injectable()
export class InternationalDataEffects {
  loadInternationalData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.RequireInternationalDataGuardActionTypes.InternationalDataNotFound),
      switchMap(() =>
        this.myCiceroWebApi.listInternationalData().pipe(
          map(mapListInternationalDataOutput),
          map((list) => new fromActions.InternationalDataLoadSuccess(list)),
          catchError(() => of(new fromActions.InternationalDataLoadFail())),
        ),
      ),
    ),
  )

  constructor(
    private readonly actions$: Actions,
    private readonly myCiceroWebApi: MyCiceroWebApiService,
  ) {}
}
